<app-collapsible-container
    [id]="'userSettings'"
    [title]="'MY_ACCOUNT.PASSWORD'"
    [icon]="'i-lock'"
    (elementSizeModification)="elementSizeModification.emit()"
>
    <form [formGroup]="newPwdForm">
        <div class="form-control">
            <label class="btn__label">{{ 'MY_ACCOUNT.OLD_PASSWORD' | translate }}</label>
            <app-password-input
                [inputConfig]="oldPwdInputConfig"
                [isValid]="oldPassword.valid"
                formControlName="oldPassword"
                (blur)="markAsTouched()"
                (input)="onInput()"
            >
                <app-form-errors *ngIf="oldPassword.touched" [errors]="oldPassword.errors"></app-form-errors>
            </app-password-input>
        </div>
        <ng-container formGroupName="passwords">
            <div class="form-control">
                <label class="btn__label">{{ 'MY_ACCOUNT.NEW_PASSWORD' | translate }}</label>
                <app-password-input [inputConfig]="newPwdInputConfig" [isValid]="newPwd.valid" formControlName="password" (blur)="markAsTouched()"
                                    (input)="onInput()">
                    <app-form-errors *ngIf="newPwd.touched" [errors]="newPwd.errors"></app-form-errors>
                </app-password-input>
            </div>
            <div class="form-control">
                <label class="btn__label">{{ 'MY_ACCOUNT.CONFIRM_NEW_PASSWORD' | translate }}</label>
                <app-password-input
                    [inputConfig]="newPwdConfirmInputConfig"
                    [isValid]="newPwdConfirm.valid"
                    formControlName="passwordConfirm"
                    (blur)="markAsTouched()"
                    (input)="onInput()"
                >
                    <app-form-errors *ngIf="newPwdConfirm.touched" [errors]="newPwdConfirm.errors"></app-form-errors>
                </app-password-input>
            </div>
            <app-form-errors *ngIf="newPwdForm.touched" [errors]="newPwdForm.errors"></app-form-errors>
        </ng-container>
    </form>
</app-collapsible-container>
